import makeCrud from '@/store/site/localization/crud'

// Medya/akış sağlayıcıları (stream/provider). CRUD: {code, name, active}.
export default makeCrud('stream_provider')
